export const COLORS = {
  text: { light: '#121111', dark: '#EAE4E4' },
  background: { light: '#EAE4E4', dark: '#121111' },
  accent: { light: '#736868', dark: '#faf5e3' },
  footer: { light: '#E8DBDB', dark: '#171717' },
};

export const COLOR_MODE_KEY = 'color-mode';
export const INITIAL_COLOR_MODE_CSS_PROP = '--initial-color-mode';
